import Domain from "@smash-sdk/domain/ejs/10-2019";
import Iam from "@smash-sdk/iam/ejs/10-2019";
import React, { useEffect } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch } from '../../../hooks/redux/hooks';
import { Team } from '../../apiKey/models/Team.interface';
import { updateTeamConfiguration } from '../domainSlice';


interface Props {
    children?: React.ReactNode;
    domain?: { domain?: Domain.GetDomainOutput['domain'] | null, team?: Team } | null; // FIX ME Fix SDK IAM and do not use local team interface
    updating?: boolean;
    updated?: boolean;
}
const DomainAuthenticationMode = (props: Props) => {
    const dispatch = useAppDispatch();

    type AuthenticationModeFormAttributes = {
        enabledAnonymous: boolean;
    };

    useEffect(() => {
        if (props.updated === true) {
            reset({}, { keepDirty: false });
        }
    }, [props.updated]);

    const { handleSubmit, reset, register, formState: { isDirty } } = useForm<AuthenticationModeFormAttributes>({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    function saveDomainAuthenticationMode({ enabledAnonymous }: AuthenticationModeFormAttributes) {
        const config: Iam.UpdateTeamInput['config'] = { authentication: { mode: enabledAnonymous ? 'Anonymous' : 'Authentified' } };
        if (props?.domain?.team?.id) {
            dispatch(updateTeamConfiguration({ teamId: props.domain?.team?.id, config }));
        }
    }

    if (props?.domain) {
        return (
            <>
                <Card>
                    <Card.Header>
                        <Row>
                            <Col md={8} sm={7} xs={7}>
                                <Card.Title>Access domain</Card.Title>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Form id={`domain-authentication-mode-${props?.domain.team}-form`} noValidate onSubmit={handleSubmit(saveDomainAuthenticationMode)}>
                        <Card.Body>
                            <Row className="d-flex align-items-center justify-content-between">
                                <Col xs={11} className="d-flex flex-column ms-1">
                                    <Row className="d-flex"><span className="text-secondary">Allow people to upload files through "{props.domain.domain?.domain}"</span></Row>
                                </Col>
                                <Col className="d-flex justify-content-end align w-auto">
                                    <Form.Check
                                        {...register('enabledAnonymous')}
                                        defaultChecked={props?.domain?.team?.config?.authentication?.mode === 'Anonymous'}
                                        style={{fontSize: "1.3rem"}}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <Row className="d-flex">
                                <Col className="d-flex justify-content-end">
                                    <Button disabled={props?.updating || !isDirty} type="submit">
                                        {!props?.updating && <span>Save</span>}
                                        {props?.updating && <span>Saving...</span>}
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Footer>
                    </Form>
                </Card>
            </>
        )
    } else {
        return (
            <>
                <SmashSpinner></SmashSpinner>
            </>
        )
    }
}

export default DomainAuthenticationMode